import { Box, Divider, ImageList, ImageListItem, Typography } from "@mui/material";
import images from '../../../../../data/images.json';

export default function HomePage() {
    const imagesArray = images.home.portraits;

    return (
        <Box sx={{ position: 'relative', height: 'calc(100vh - 200px)', overflow: 'hidden' }}>
            {/* Background masonry image list */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflowY: 'hidden',
                    zIndex: 0,
                }}
            >
                <ImageList variant="masonry" cols={7} gap={8}>
                    {imagesArray.map((image, i) => (
                        <ImageListItem key={`Image_${i}`}>
                            <img
                                srcSet={`${image.src}?w=100&fit=crop&auto=format&dpr=2 2x`}
                                src={`${image.src}?w=100&fit=crop&auto=format`}
                                alt={image.alt}
                                loading="lazy"
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Box>

            {/* Foreground content */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    padding: 4,
                    maxWidth: '600px',
                    margin: '0 auto',
                    mt: 8,
                    borderRadius: 2,
                }}
            >
                <Typography>Ώρες λειτουργείας:</Typography>
                <Typography>Καθημερινές, 17:00 το απόγευμα - 1:00 το βράδυ</Typography>
                <Typography>Σάββατο & Κυριακή, 13:00 το μεσημέρι - 1:00 το βράδυ</Typography>
                <Divider sx={{m:1}} />
                <Typography sx={{m:1}}>
                    Από το 1984 μεράκι και παράδοση
                </Typography>
                <Typography sx={{m:1}}>
                    Στην καρδιά του Πόρτο Ράφτη μια οικογενεική ταβέρνα "ο Αποστόλης" γεμάτο ιστορία, αυθεντικές γεύσεις, φιλοξενία και.... πολλές αναμνήσεις. <br/> 
                    Εδώ, τίποτα δεν γίνεται βιαστικά, γιατί για εμάς κάθε πιάτο είναι υπόσχεση ότι η παράδοση κρατιέται ζωντανή.
                </Typography>
                <Typography>
                    Καλώς Ορίσατε, <br/>εκεί που η γεύση έχει ιστορία
                </Typography>
            </Box>
        </Box>
    );
}